<template>
    <div id="container">

        <div id="map_view">
            <div id="edit_view">
                <!-- <el-button type="success" size="small" @click.stop="switchToSatelliteMap()"
                    style="background-color: #3CA757;color: #FFFFFF;">卫星地图</el-button> -->
                <div style="display: flex; flex-direction: column; align-items: center; margin-right: 10px;">
                    <div style="display: flex; align-items: center; margin-bottom: 10px;">
                        <el-button size="small" @click.stop="isDrawing ? handleCancelDraw() : handleAdd()"
                            :class="{ 'draw-button': true, 'draw-button-disabled': hasDrawn }" :disabled="hasDrawn" style="margin-right: 10px;">{{ isDrawing ? '取消绘制' : '绘制' }}</el-button>
                        <el-button size="small" @click.stop="handleClearDraw()"
                            :class="{ 'draw-button': true, 'draw-button-disabled': !hasDrawn }" :disabled="!hasDrawn">清除</el-button>
                    </div>
                    <div style="font-size: 12px; color: #333; background-color: #f5f5f5; padding: 10px; border-radius: 6px; border: 1px solid #ddd; line-height: 1.4; text-align: center;">
                        左键点击绘制<br>
                        右键撤回<br>
                        双击结束绘制自动闭合
                    </div>
                </div>
                <el-button type="success" size="small" @click.stop="saveElectronicFence()"
                    style="background-color: #3CA757;color: #FFFFFF;">保存</el-button>
                <el-button type="success" size="small" @click.stop="handDelete()"
                    style="background-color: #3CA757;color: #FFFFFF;">删除</el-button>
                <el-select v-if="this.user == 'admin'" class="distributor_select" :clearable=true
                    v-model="saveElectronicFenceReq.distributorId" :filterable=true placeholder="请选择运营商">
                    <el-option v-for="item in distributorOptions" :key="item.key" :label="item.value" :value="item.key">
                    </el-option>
                </el-select>
            </div>


        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            user: '',
            geometrieList: [],
            electronicFenceList: [],
            saveElectronicFenceReq: {
                distributorId: '',
                name: '',
                saveElectronicFenceListReq: [],
            },
            hasDrawn: false,
            isDrawing: false,
            distributorInfo: {},
            distributorOptions: [],
            map: null,
            editor: null,
            markerLayer: null,
            multiLabel: null
        }
    },
    mounted() {
        this.user = window.sessionStorage.getItem('user');
        this.initDistributorInfo();
        this.getElectronicFenceList();
    },
    methods: {
        initMap() {
            //定义地图中心点坐标
            var center = new TMap.LatLng(32.916652, 117.358006)
            //定义map变量，调用 TMap.Map() 构造函数创建地图
            this.map = new TMap.Map(document.getElementById('map_view'), {
                center: center,//设置地图中心点坐标
                zoom: 10,   //设置地图缩放级别
                // pitch: 43.5,  //设置俯仰角
                // rotation: 45    //设置地图旋转角度
                // 可以直接在这里设置地图类型，但也可以在之后通过 setMapTypeId 修改
                // mapTypeControl: true, // 是否显示地图类型控件（卫星、混合等）
                // mapTypeId: 'satellite' // 初始化为普通地图
            });

            //创建并初始化MultiMarker
            this.markerLayer = new TMap.MultiMarker({
                map: this.map,  //指定地图容器
                //样式定义
                styles: {
                    highlight: new TMap.MarkerStyle({
                        color: 'rgba(255, 255, 0, 0.6)'
                    })
                },
            });
            




            this.editor = new TMap.tools.GeometryEditor({
                map: this.map,
                // 可编辑图层
                overlayList: [
                    {
                        id: 'polygon1', // 随便给的
                        selectedStyleId: 'highlight',
                        overlay: new TMap.MultiPolygon({
                            map: this.map,
                            // 样式
                            styles: {
                                highlight: new TMap.PolygonStyle({
                                    color: 'rgba(255, 255, 0, 0.6)'
                                })
                            },
                            //点标记数据数组
                            geometries: this.geometrieList

                        })
                    },
                ],
                // actionMode: TMap.tools.constants.EDITOR_ACTION.DRAW, //编辑器的工作模式  DRAW INTERACT 绘制 INTERACT 选中
                actionMode: TMap.tools.constants.EDITOR_ACTION.INTERACT, //编辑器的工作模式  DRAW INTERACT 绘制 INTERACT 选中
                snappable: true, // 开启邻近吸附
                selectable: true,// 开启点选功能
                activeOverlayId: 'polygon1', // 激活图层
            });
            // 开始监听几何图形
            this.editor.on('draw_complete', geometry => {
                this.saveElectronicFenceReq.saveElectronicFenceListReq.push(geometry.paths);
                console.log('this.saveElectronicFenceReq', this.saveElectronicFenceReq);
                this.hasDrawn = true;
                this.isDrawing = false;
                // 绘制完成后，将编辑器切换到选择模式，防止继续绘制
                this.editor.setActionMode(1);
            })

            // 监听删除、修改、拆分、合并完成事件
            let evtList = ['delete', 'adjust', 'split', 'union'];
            evtList.forEach(evtName => {
                if (evtName == 'delete') {
                    this.editor.on(evtName + '_complete', evtResult => {
                        console.log(evtName, evtResult);
                        this.deleteElectronicFenceList(evtResult);
                    });
                }
            });
        },
        handleAdd() {
            // 如果已经绘制完成，则不允许再次绘制
            if (this.hasDrawn) {
                return;
            }
            // 指定图层处于编辑状态
            // editor.setActiveOverlay("polygon1");
            this.editor.setActionMode(2);
            this.isDrawing = true;
            console.log("editor:", this.editor);
        },
        // 取消绘制
        handleCancelDraw() {
            // 切换到选择模式
            this.editor.setActionMode(1);
            this.isDrawing = false;
            console.log("取消绘制");
        },
        // 清除绘制的电子围栏（只清除当前绘制未保存的）
        handleClearDraw() {
            // 重置保存请求数据
            this.saveElectronicFenceReq.saveElectronicFenceListReq = [];
            // 重置状态
            this.hasDrawn = false;
            this.isDrawing = false;
            // 清除编辑器中当前绘制的几何图形
            if (this.editor) {
                try {
                    // 获取编辑器的覆盖物列表
                    let overlayList = this.editor.getOverlayList();
                    if (overlayList && overlayList.length > 0) {
                        // 获取第一个覆盖物
                        let overlay = overlayList[0].overlay;
                        if (overlay && overlay.setGeometries) {
                            // 只显示已保存的电子围栏
                            let savedGeometries = [];
                            if (this.electronicFenceList) {
                                for (let index in this.electronicFenceList) {
                                    let fence = this.electronicFenceList[index];
                                    let polygonPaths = fence.paths.map(function (point) {
                                        return new TMap.LatLng(point.lat, point.lng);
                                    });
                                    savedGeometries.push({ paths: polygonPaths });
                                }
                            }
                            // 设置覆盖物的几何图形为已保存的围栏
                            overlay.setGeometries(savedGeometries);
                            console.log("清除未保存的几何图形成功");
                        }
                    }
                    // 切换到选择模式
                    this.editor.setActionMode(1);
                } catch (error) {
                    console.error("清除绘制失败:", error);
                }
            }
            console.log("清除绘制");
        },
        // 计算多边形中心点
        calculateCenter(paths) {
            let latSum = 0;
            let lngSum = 0;
            for (let i = 0; i < paths.length; i++) {
                latSum += paths[i].getLat();
                lngSum += paths[i].getLng();
            }
            return new TMap.LatLng(latSum / paths.length, lngSum / paths.length);
        },

        handDelete() {
            this.$confirm("确认删除已选中的电子围栏吗？", {
                title: "提示",
                type: 'warning',
            }).then(resc => {
                this.editor.delete();
            });
        },
        saveElectronicFence() {
            // 验证运营商选择
            if (this.user === 'admin' && !this.saveElectronicFenceReq.distributorId) {
                this.$message.error('请选择运营商');
                return;
            }
            
            // 弹出弹框让用户输入电子围栏名称
            this.$prompt('请输入电子围栏名称', '保存电子围栏', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                inputValidator: (value) => {
                    if (!value || value.trim() === '') {
                        return '请输入电子围栏名称';
                    }
                    return true;
                }
            }).then(({ value }) => {
                // 设置电子围栏名称
                this.saveElectronicFenceReq.name = value.trim();
                
                // 调用保存接口
                this.$http.post('/device/manager/table/save', this.saveElectronicFenceReq).then((res) => {
                    if (res.data.code != 200) return this.$message.error(res.data.msg);
                    this.$message.success(res.data.msg);
                    window.location.reload();
                });
            }).catch(() => {
                // 用户取消输入
                console.log('用户取消输入电子围栏名称');
            });
        },
        getElectronicFenceList() {
            this.$http.get('/device/manager/table/getElectronicFenceList').then((res) => {
                console.log("查询电子围栏：", res);
                if (res.data.code == 200) {
                    console.log('res.data.data', res.data.data);
                    this.electronicFenceList = res.data.data;
                    if (this.electronicFenceList) {
                        for (let index in this.electronicFenceList) {
                            var polygonPaths = this.electronicFenceList[index].paths.map(function (point) {
                                return new TMap.LatLng(point.lat, point.lng);
                            });
                            console.log('polygonPaths:', polygonPaths)
                            this.geometrieList.push({ paths: polygonPaths });
                        }
                        console.log('this.geometrieList:', this.geometrieList)
                    }
                }
                // 使用$nextTick确保DOM完全加载后再初始化地图
                this.$nextTick(() => {
                    this.initMap();
                    // 显示电子围栏名称
                    this.showElectronicFenceNames();
                });
            })
        },
        // 显示电子围栏名称
        showElectronicFenceNames() {
            if (!this.electronicFenceList || this.electronicFenceList.length === 0) {
                return;
            }
            
            let labelGeometries = [];
            for (let index in this.electronicFenceList) {
                let fence = this.electronicFenceList[index];
                let polygonPaths = fence.paths.map(function (point) {
                    return new TMap.LatLng(point.lat, point.lng);
                });
                // 计算中心点
                let center = this.calculateCenter(polygonPaths);
                // 添加标签
                labelGeometries.push({
                    id: fence.id,
                    position: center,
                    content: fence.name || '未命名围栏',
                    styleId: 'label'
                });
            }
            
            // 创建新的MultiLabel实例
            if (this.multiLabel) {
                this.multiLabel.remove();
            }
            
            this.multiLabel = new TMap.MultiLabel({
                map: this.map,
                geometries: labelGeometries,
                styles: {
                    label: new TMap.LabelStyle({
                        color: '#FFFFFF',
                        size: 14,
                        backgroundColor: '#3CA757',
                        borderColor: '#FFFFFF',
                        borderWidth: 2,
                        borderRadius: 8,
                        padding: '10px',
                        offset: { x: 0, y: 0 }
                    })
                }
            });
        },
        deleteElectronicFenceList(evtResult) {
            console.log('deleteElectronicFenceList:', evtResult)
            this.$http.post('/device/manager/table/deleteElectronicFenceList', evtResult).then((res) => {
                console.log("删除电子围栏：", res);
                if (res.data.code != 200) return this.$message.error(res.data.msg);
                this.$message.success(res.data.msg);
                window.location.reload();
            });
        },
        initDistributorInfo() {
            if (this.user == 'admin') {
                this.distributorInfo = {};
                this.$http.get('/distributor/manager/getAllDistributorInfo').then((res) => {
                    this.distributorOptions = [];
                    if (res.data.code != 200) return this.$message.error(res.data.msg);
                    let distributorInfoList = res.data.data;
                    for (let index in distributorInfoList) {
                        this.distributorOptions.push({ key: distributorInfoList[index].id, value: distributorInfoList[index].name });
                    }
                    console.log('this.distributorOptions：', this.distributorOptions);
                });
            }
        },
		// switchToSatelliteMap() {
        //     // 切换到卫星地图
        //     map.setMapTypeId('satellite');  // 使用'satellite'图层样式
		// }

    },
}

</script>
<style scoped>
#container {
    position: relative;
    width: 100%;
    height: 100vh;
    min-height: 600px;
}

#map_view {
    width: 100%;
    height: 100%;
    overflow: hidden;
}

#edit_view {
    display: flex;
    position: absolute;
    left: 65%;
    top: 2%;
    z-index: 2000;
}

.draw-button {
    background-color: #3CA757;
    color: #FFFFFF;
    border: none;
}

.draw-button:hover {
    background-color: #3CA757;
    color: #FFFFFF;
    border: none;
}

.draw-button:active {
    background-color: #3CA757 !important;
    color: #FFFFFF !important;
    border: none !important;
}

.draw-button:focus {
    background-color: #3CA757 !important;
    color: #FFFFFF !important;
    border: none !important;
    outline: none !important;
}

.draw-button:disabled,
.draw-button-disabled {
    background-color: #CCCCCC !important;
    color: #FFFFFF !important;
    border: none !important;
    cursor: not-allowed !important;
}

.distributor_select {
    margin-left: 10px;
}
</style>